import {Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import {AjaxService} from 'AjaxService';
import {RememberService} from 'RememberService';

@Component({
    selector: 'aBe-e-uebersicht',
    templateUrl: './aBe-e-uebersicht.component.html',
    styleUrls: ['./aBe-e-uebersicht.component.css'],
    standalone: false
})
export class AntragBeExternUebersichtComponent implements OnInit, OnDestroy {
  @Input() paths: string[];
  @Output() pathsChange = new EventEmitter<string[]>();

  @Input() antragBeId: number;
  @Output() onRdy = new EventEmitter<any>();

  data: any;
  loading: number = 1;

  p: any = {};

  constructor(private ajaxService: AjaxService, private rememberService: RememberService) {}

  load() {
    this.startLoading(1);
    this.ajaxService.post<any>('api/ExternAntragBe/GetUebersicht', {antragBeId: this.antragBeId}).subscribe({
      next: (response) => {
        this.data = response;
        this.stopLoading();
      },
      error: (e) => {
        this.stopLoading();
        throw e;
      },
    });
  }

  ngOnInit(): void {
    const path_array = this.rememberService.LoadFromSession('navPath');
    if (path_array) {
      path_array.push('Übersicht');
      this.rememberService.SaveFromSession('navPath', path_array);
    }

    this.load();
  }

  ngOnDestroy(): void {
    let path_array = this.rememberService.LoadFromSession('navPath');
    if (path_array) {
      path_array = path_array.filter((x) => x !== 'Übersicht');
      this.rememberService.SaveFromSession('navPath', path_array);
    }
  }

  getEinrichtungsteilCaption(ue, i) {
    return i + 1 + '. Einrichtung (' + ue.name + ')';
  }

  getPersonalCaption(p, u) {
    return u + 1 + '. ' + p.name;
  }

  calculateCellValue_Bis(event: any) {
    if (event) {
      if (event.bisJetzt) {
        return 'bis jetzt';
      }

      if (event.bis) {
        return new Date(event.bis).toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'});
      }
    }

    return '';
  }

  onAbbruch() {
    this.onRdy.emit(null);
  }

  download(name, bez) {
    const re = /\./gi;
    const fileName = new Date().toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).replace(re, '-') + '_' + bez + this.getFileExtension1(name);
    this.ajaxService.download('/api/Dokument/Download?fileName=' + name + '&dokumentName=' + bez, fileName);
  }

  getFileExtension1(filename) {
    return /[.]/.exec(filename) ? '.' + /[^.]+$/.exec(filename)[0] : undefined;
  }

  startLoading(state: number) {
    this.loading = state;
  }

  stopLoading() {
    this.loading = 0;
  }
}
